import React, { useContext, useEffect, useRef, useState } from "react";
import { BookOpen, FileText, Upload } from "lucide-react";
import "../../../assests/css/teachers/TeacherGuessPaper.css";
import TeacherMasterLayout from "../../../layouts/TeacherMasterLayout";
import axios from "axios";
import { AppContext, AppProvider } from "../../../context/Appcontext";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import { Spinner } from "react-bootstrap";

const subjects = [
  "Mathematics",
  "Physics",
  "Chemistry",
  "Computer Science",
  "Biology",
];

const TeacherGuessPaper = () => {
  const { baseUrl, baseUrlForFiles, loggedInTeacher } = useContext(AppContext);
  const fileInputRef = useRef(null);
  const [showModal, setShowModal] = useState(false);

  const [showForm, setShowForm] = useState(false);
  const [course, setCourse] = useState("");
  const [courses, setCourses] = useState([]);
  const [fileName, setFileName] = useState(null);
  // const [selectedFile, setSelectedFile] = useState(null);
  const [uploads, setUploads] = useState([]);
  const [noteIdForUpdate, setNoteIdForUpdate] = useState(null);
  const [addActionLoading, setAddActionLoading] = useState(false);

  const resetForm = () => {
    setCourse("");

    setFileName("");
    setNoteIdForUpdate(null);
  };

  const handleSubmit = () => {
    setAddActionLoading(true);
    if (noteIdForUpdate === null) {
      createNotes();
      // } else {
      //   updateProgramme();
    }
    // setAddActionLoading(false);
  };
  const handleUploadClick = () => {
    setShowForm(true);
    setCourse("");
    // setSelectedFile(null);
    setFileName(null);
  };

  const handleCourseChange = (e) => {
    setCourse(e.target.value);
  };

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setSelectedFile(file);
  //   }
  // };

  // const handleAddToTable = () => {
  //   if (!course || !selectedFile) return;

  //   setUploads((prev) => [
  //     { subject: course, file: selectedFile.name },
  //     ...prev,
  //   ]);

  //   setCourse("");
  //   setSelectedFile(null);
  //   if (fileInputRef.current) fileInputRef.current.value = "";
  //   setShowForm(false);
  // };

  const createNotes = () => {
    console.log("Teacher ID:", loggedInTeacher?.id);
    const formData = new FormData();
    formData.append("ngteacher_id", loggedInTeacher?.id);
    formData.append("ngcourse_id", course);

    if (fileName) formData.append("fileName", fileName);
    console.log(loggedInTeacher);
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }
    axios
      .post(`${baseUrl}/teacher/notes/createNotes`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response.data);
        setAddActionLoading(false);
        if (response.data.success === true) {
          viewAllNotes();
          resetForm();
          setShowModal(false);
          Swal.fire({
            icon: "success",
            title: "Notes uploaded successfully!",
            confirmButtonText: "Okay",
          });
        }
      })
      // .catch((error) => {
      //   console.log(error);
      // });
      .catch((error) => {
        console.log("FULL ERROR:", error);
        console.log("RESPONSE:", error.response);
        console.log("DATA:", error.response?.data);

        Swal.fire({
          icon: "error",
          title: "Server Error",
          text: error.response?.data?.message || "Something went wrong",
        });
      });
  };
  const viewAllCourses = () => {
    const formData = new FormData();

    formData.append("ngteacher_id", loggedInTeacher.id);

    axios.post(
      `${baseUrl}/teacher/course/viewAllTeacherCourse`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    )
      .then((response) => {
        console.log(response.data);
        console.log(response.data.courses);
        setCourses(response.data.courses);
      });
  }
const viewAllNotes = () => {
  const formData = new FormData();

  formData.append("ngteacher_id", loggedInTeacher?.id);

  axios
    .post(`${baseUrl}/teacher/notes/viewAllNotes`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      console.log(response.data);
      setUploads(response.data.notes);
    })
    .catch((error) => {
      console.log(error);
    });
};
  useEffect(() => {
    if (loggedInTeacher) {
      viewAllCourses();
      viewAllNotes();
    }
  }, [loggedInTeacher]);

  return (
    <TeacherMasterLayout>
      <header className="tgp-topbar">
        <h3>Welcome, Teacher 👋</h3>
        <div className="tgp-profile">👤</div>
      </header>

      <div className="tgp-wrapper">
        {/* Header */}
        <div className="tgp-header">
          <div>
            <h1>Notes</h1>
            <p>Upload and manage your Notes</p>
          </div>

          <button className="tgp-upload-main-btn" onClick={handleUploadClick}>
            <Upload size={18} /> Upload Notes
          </button>
        </div>

        {/* Stats */}
        <div className="tgp-stats">
          <div className="tgp-stat-card">
            <div>
              <p>Total Uploads</p>
              <h2>{uploads.length}</h2>
            </div>
            <Upload className="tgp-icon blue" />
          </div>

          <div className="tgp-stat-card">
            <div>
              <p>Courses</p>
              <h2>{courses.length}</h2>
            </div>
            <FileText className="tgp-icon peach" />
          </div>
        </div>

        {/* Upload Form */}
        {showForm && (
          <>
            <h3 className="tgp-form-title">Upload Notes</h3>
            <select
              // id="tm-status"
              className="form-control"
              value={course}
              onChange={(e) => setCourse(e.target.value)}
            >
              <option value="0">SELECT COURSE</option>

              {courses.map((course) => {
                return (
                  <option key={course.ngcourse.id} value={course.ngcourse.id}>
                    {course.ngcourse.name}
                  </option>
                );
              })}
            </select>
            <input
              type="file"
              accept="*"
              onChange={(e) => setFileName(e.target.files[0])}
              className="form-control mt-3"
            />
            <div className="tgp-form-actions">
              <button
                className="tgp-cancel-btn"
                onClick={() => setShowForm(false)}
              >
                Cancel
              </button>
              {addActionLoading ? (
                <Spinner size="lg" />
              ) : (
                <button
                  className="tgp-add-btn"
                  // onClick={handleAddToTable}
                  // disabled={!course || !selectedFile}
                  disabled={!course || !fileName}
                  onClick={handleSubmit}
                >
                  Add to Table
                </button>
              )}
            </div>
          </>
        )}

        {/* Table */}
        <div className="tgp-table-card">
          <div className="tgp-table-header">
            <h3>Recent Uploads</h3>
          </div>

          {uploads.length === 0 ? (
            <p className="tgp-empty-msg">
              No uploads yet. Click "Upload Notes" to get started.
            </p>
          ) : (
            <>
              <table className="tgp-desktop-table">
                <thead>
                  <tr>
                    <th>Course / Exam</th>
                    <th>File Name</th>
                  </tr>
                </thead>
                <tbody>
                  {uploads.map((item, index) => (
                    <tr key={index}>
                      <td>{item.ngcourse?.name}</td>
                      <td>
                        <a
                          target="_blank"
                          href={`${baseUrlForFiles}/${item.fileName}`}
                        >
                          {item.fileName}
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Mobile */}
              <div className="tgp-mobile-cards">
                {uploads.map((item, index) => (
                  <div key={index} className="tgp-mobile-card">
                    <FileText size={18} />
                    <div>
                      <strong>{item.subject}</strong>
                      <p>{item.file}</p>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </TeacherMasterLayout>
  );
};

export default TeacherGuessPaper;
